var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 11.8C14.6001 12.5732 15.2269 13.2 16.0001 13.2C16.7733 13.2 17.4001 12.5732 17.4001 11.8C17.4001 11.0268 16.7733 10.4 16.0001 10.4C15.2269 10.4 14.6001 11.0268 14.6001 11.8Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 16.0001C14.6001 16.7733 15.2269 17.4001 16.0001 17.4001C16.7733 17.4001 17.4001 16.7733 17.4001 16.0001C17.4001 15.2269 16.7733 14.6001 16.0001 14.6001C15.2269 14.6001 14.6001 15.2269 14.6001 16.0001Z",
    fill: "#172B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 20.2001C14.6001 20.9733 15.2269 21.6001 16.0001 21.6001C16.7733 21.6001 17.4001 20.9733 17.4001 20.2001C17.4001 19.4269 16.7733 18.8 16.0001 18.8C15.2269 18.8 14.6001 19.4269 14.6001 20.2001Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.6b4cb27251cfc9672a56f62eedc94fad.svg";
export { ForwardRef as ReactComponent };